export const whatIsSatelitEdges = [
  {
    id: "31.172.218.103-9c8f:7a36::818f:b57a:68a1",
    source: "31.172.218.103",
    target: "9c8f:7a36::818f:b57a:68a1",
    type: "straight",
  },
  {
    id: "31.172.218.103-182.49.39.109",
    source: "31.172.218.103",
    target: "182.49.39.109",
    type: "straight",
  },
  {
    id: "182.49.39.109-192.135.109.25",
    source: "182.49.39.109",
    target: "192.135.109.25",
    type: "straight",
  },
];
